module.exports = __webpack_public_path__ + "static/media/getPro-bg.f9f4097d.png";